export default __webpack_public_path__ + "static/media/services-pools.cd11e1a8.jpg";